{
  "button": {
    "auto": "Auto",
    "cancel": "Cancelar",
    "connectWallet": "Conectar billetera",
    "contactSupport": "Contactar soporte",
    "continue": "Continuar",
    "copyAddress": "Copiar dirección",
    "dark": "Oscuro",
    "delete": "Eliminar",
    "disconnect": "Desconectar",
    "done": "Hecho",
    "getGas": "Obtener gas",
    "hide": "Esconder",
    "lifiSwap": "LI.FI Swap",
    "light": "Luz",
    "max": "máximo",
    "ok": "Ok",
    "okay": "Okay",
    "removeSwap": "Eliminar swap",
    "reset": "Reiniciar",
    "resetSettings": "Reiniciar ajustes",
    "restartSwap": "Reiniciar swap",
    "reviewGasSwap": "Revisar swap de gas",
    "reviewSwap": "Revisar swap",
    "seeDetails": "Ver detalles",
    "showAll": "Mostrar todo",
    "startGasSwap": "Iniciar intercambio de gas",
    "startSwap": "Iniciar swap",
    "swap": "Swap",
    "tryAgain": "Intentar otra vez",
    "viewOnExplorer": "Ver en explorador"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 4)}}"
  },
  "header": {
    "activeSwaps": "Swaps activos",
    "checkout": "Checkout",
    "from": "Intercambiar de",
    "gas": "Gas",
    "gasSwap": "Swap de gas",
    "routes": "Usted obtiene",
    "selectChain": "Seleccione la cadena",
    "selectWallet": "Seleccione su billetera",
    "settings": "Ajustes",
    "swap": "Swap",
    "swapDetails": "Detalles del swap",
    "swapHistory": "Historial de swaps",
    "to": "Swap a",
    "walletConnected": "Billetera conectada"
  },
  "language": {
    "name": "Español",
    "title": "Idioma"
  },
  "settings": {
    "enabledBridges": "Puentes habilitados",
    "enabledExchanges": "Intercambios habilitados",
    "gasPrice": {
      "fast": "Rápido",
      "normal": "Normal",
      "slow": "Lento",
      "title": "Precio de gas"
    },
    "routePriority": "Prioridad de ruta",
    "showDestinationWallet": "Mostrar billetera de destino",
    "slippage": "Diferencial"
  },
  "info": {
    "message": {
      "emptyActiveSwaps": "Los intercambios en curso aparecerán aquí. Una vez completado, encuéntrelos en el historial de intercambio.",
      "emptySwapHistory": "El historial de intercambio solo se almacena localmente y se eliminará si borra los datos de su navegador.",
      "emptyTokenList": "No pudimos encontrar tokens en la cadena {{chainName}} o no tienes ninguno. Por favor intente buscar de nuevo o elija otra cadena.",
      "routeNotFound": "Pruebe con otra combinación de tokens."
    },
    "title": {
      "emptyActiveSwaps": "No hay intercambios activos",
      "emptySwapHistory": "No hay intercambios recientes",
      "routeNotFound": "No hay rutas disponibles"
    }
  },
  "success": {
    "message": {
      "swapPartiallySuccessful": "Hemos intentado completar el swap, pero {{tool}} se quedó sin liquidez para el token {{tokenSymbol}}.",
      "swapSuccessful": "Ahora hay {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en la billetera {{walletAddress}} en la cadena {{chainName}}."
    },
    "title": {
      "gasSwapSuccessful": "Swap de gas exitoso",
      "refundIssued": "Reembolso emitido",
      "swapPartiallySuccessful": "Swap parcialmente exitoso",
      "swapSuccessful": "Intercambio exitoso"
    }
  },
  "warning": {
    "message": {
      "deleteActiveSwaps": "Los intercambios activos solo se almacenan localmente y no se pueden recuperar si los elimina.",
      "deleteSwapHistory": "El historial de intercambio solo se almacena localmente y no se puede recuperar si lo elimina.",
      "highValueLoss": "El valor de los tokens recibidos es significativamente menor que los tokens intercambiados y el costo de la transacción.",
      "insufficientFunds": "No tiene fondos suficientes para ejecutar el intercambio.",
      "insufficientGas": "Debes agregar al menos:",
      "rateChanged": "La tasa de cambio ha cambiado. Continuar con el swap implica que estas de acuerdo con la nueva tasa.",
      "resetSettings": "Esto restablecerá su prioridad de ruta, deslizamiento, precio de gas, puentes e intercambios habilitados."
    },
    "title": {
      "deleteActiveSwaps": "¿Eliminar todos los intercambios activos?",
      "deleteSwap": "¿Eliminar este intercambio?",
      "deleteSwapHistory": "¿Eliminar el historial de intercambio?",
      "highValueLoss": "Pérdida de alto valor",
      "insufficientGas": "Gas insuficiente",
      "rateChanged": "Cambios de precio detectado",
      "resetSettings": "¿Reiniciar los ajustes?"
    }
  },
  "error": {
    "message": {
      "slippageThreshold": "El slippage es mayor que el umbral definido. Por favor, solicite una nueva ruta para obtener un presupuesto nuevo.",
      "transactionFailed": "Por favor consulte el explorador de bloques para obtener mas información",
      "transactionNotSent": "La transacción no fue enviada, sus fondos aún están en su billetera ({{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en {{chainName}}).",
      "transactionRejected": "Se requiere su firma para completar la transacción. {{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} en {{chainName}} permanecen en su billetera.",
      "unknown": "Inténtalo de nuevo o ponte en contacto con soporte."
    },
    "title": {
      "balanceIsTooLow": "El balance es demasiado bajo",
      "chainSwitch": "Se requiere cambiar cadena.",
      "failed": "Swap ha fallado",
      "gasLimitIsTooLow": "Límite de gas es demasiado bajo",
      "slippageNotMet": "Condiciones de slippage no cumplidas",
      "transactionCanceled": "Transacción cancelada",
      "transactionFailed": "La transacción ha fallado.",
      "transactionRejected": "Firma requerida.",
      "transactionUnderpriced": "La transacción está subvaluada.",
      "transactionUnprepared": "No se puede preparar la transacción.",
      "unknown": "Algo salió mal.",
      "walletAddressInvalid": "La dirección de la billetera no es válida.",
      "walletAddressRequired": "Dirección de billetera es requerida.",
      "walletEnsAddressInvalid": "La dirección de la billetera no es válida o la red no es compatible con ENS."
    }
  },
  "main": {
    "crossStepDetails": "Mover fondos de {{from}} {{to}} {{tool}}",
    "currentAmount": "Cantidad actual",
    "estimatedTime": "{{value}}m",
    "featuredTokens": "Tokens destacados",
    "from": "Desde",
    "fromAmount": "Usted paga",
    "gasCost": "Costo de gas",
    "gasFeeEstimated": "tarifa de gas estimada",
    "gasFeePaid": "comisión de gas pagada",
    "inProgress": "en progreso",
    "nftStepDetails": "Compra NFT a través de {{tool}}",
    "onChain": "en {{chainName}}",
    "otherTokens": "Otros tokens",
    "ownedBy": "Propiedad de",
    "payWith": "Pagar con",
    "process": {
      "crossChain": {
        "actionRequired": "Por favor firme la transacción.",
        "done": "Transacción aprobada.",
        "pending": "Esperando transacción.",
        "started": "Preparando transacción."
      },
      "receivingChain": {
        "done": "Fondos recibidos.",
        "partial": "Transacción de bridge parcialmente completada",
        "pending": "Esperando cadena de recepción.",
        "refunded": "Transacción de bridge reembolsada"
      },
      "swap": {
        "actionRequired": "Por favor firme la transacción.",
        "done": "Swap completado.",
        "pending": "Esperando transacción del intercambio",
        "started": "Preparando transacción de intercambio"
      },
      "switchChain": {
        "actionRequired": "Cambiar cadenas es requerido",
        "done": "Cadena cambiada con éxito"
      },
      "tokenAllowance": {
        "done": "Permiso de token aprobado",
        "pending": "Esperando permiso de token",
        "started": "Configurando permiso de tokens"
      }
    },
    "quotedAmount": "Monto citado",
    "rateChange": "Cambios de precio detectado",
    "receiving": "Recibiendo",
    "routes": "Usted obtiene",
    "selectChain": "Cadena",
    "selectChainAndToken": "Seleccione cadena y token",
    "selectToken": "Token",
    "sendToAddress": "Enviar a {{address}}",
    "sendToWallet": "Enviar a una billetera diferente",
    "sentToAddress": "Enviado a {{address}}",
    "stepBridge": "Cruzar",
    "stepSwap": "Swap",
    "stepSwapAndBridge": "Swap y cruzar",
    "supportId": "ID de soporte",
    "swapStepDetails": "Intercambiar en {{chain}} a través de {{tool}}",
    "swapping": "Intercambiando",
    "tags": {
      "ALTERNATIVE": "ALTERNATIVO",
      "CHEAPEST": "BARATO",
      "FASTEST": "RÁPIDO",
      "RECOMMENDED": "RECOMENDADO",
      "SAFEST": "SEGURO"
    },
    "to": "A",
    "tokenOnChain": "{{tokenSymbol}} en {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 4)}} {{tokenSymbol}} on {{chainName}}",
    "tokenSearch": "Busque su token",
    "valueLoss": "Valor perdido",
    "walletAddressOrEns": "Dirección de billetera o nombre ENS"
  },
  "tooltip": {
    "estimatedNetworkFee": "Tarifa de red estimada.",
    "estimatedTime": "Tiempo estimado de ejecución del swap en minutos.",
    "notFound": {
      "text": "No pudimos encontrar esta página.",
      "title": "404"
    },
    "numberOfSteps": "Una serie de pasos de intercambio. Cada paso puede contener 1-2 transacciones que requieren una firma.",
    "progressToNextUpdate": "Los datos mostrados se actualizarán automáticamente después de {{value}} segundos. Haga clic aquí para actualizar manualmente.",
    "settingsModified": "Ajustes (modificados)"
  },
  "wallet": {
    "extensionNotFound": "Por favor, asegúrese de que sólo la extensión {{name}} del navegador esta activa antes de elegir esta billetera."
  }
}
